import { API_BASE_PATH_ADMIN } from '../../constants';
import DefaultMapper from '../../dataProvider/DefaultMapper'

class AccountingAccountMapper extends DefaultMapper {

	mapResource({ resource }) {
		return 'accounting/accounts'
	}

	prepareUpdate(props) {
		const { params, options, mappedResource } = props;
		super.prepareUpdate(props);
		switch (params.action) {
			case 'UpdateTrafficType':
				options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/${params.id}/traffic-type`;
				options.body = JSON.stringify({
					trafficType: params.data.trafficType,
				});
				break;
			default:
				break;
		}
	}

}

export default AccountingAccountMapper
